import type { IFramework } from '@/framework';

export const getHierarchyFrameId = (framework: IFramework) => {
    const { edgelessCanvas, frame } = framework.service;
    if (edgelessCanvas.isEdgelessMode) {
        // 无限画布未选择 Frame 时回到根画布数据源，frameId = 0 不沿用上一次选择。
        return frame.getFrameSelectionFrameId() ?? 0;
    }
    return frame.getActiveFrameId();
};

export const onHierarchyFrameIdChange = (framework: IFramework, callback: (frameId: number) => void) => {
    const { edgelessCanvas, events, frame } = framework.service;
    // 两种模式的 Frame 真相源不同：无限画布跟随选区，普通模式跟随活动页。
    const listener = edgelessCanvas.isEdgelessMode
        ? frame.onFrameSelectionChange((_indexes, frameIds) => callback(frameIds[frameIds.length - 1] ?? 0))
        : frame.onActiveIndexChange(() => callback(frame.getActiveFrameId()));

    return () => events.off(listener);
};
